

export default {
    path: 'st',
    name: 'project-settings',
    props: true,
    component: () => import("@/components/temp/Temp"),
}